import { Tooltip } from "antd";
import React, { ReactNode } from "react";

import UserIcon from "@/app/icons/userIcon";

type MapTooltipProps = {
  flagIcon: ReactNode;
  countryName: string;
  countryCode: string;
  children: React.ReactNode;
  bgColor: string;
};

const MapTooltip = ({
  flagIcon,
  countryName,
  countryCode,
  children,
  bgColor,
}: MapTooltipProps) => {
  return (
    <Tooltip
      title={
        <div className="flex items-center gap-3 p-2">
          <div
            className={`${bgColor} flex items-center justify-center w-10 h-10 rounded-lg`}
          >
            {flagIcon}
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-sm text-regal-black-lighter">
              {countryName}
            </span>
            <div className="flex gap-2 items-center">
              <UserIcon />
              <span className="text-sm text-regal-black-lighter">
                {countryCode}
              </span>
            </div>
          </div>
        </div>
      }
      placement="top"
    >
      {children}
    </Tooltip>
  );
};

export default MapTooltip;
